module.exports = __webpack_public_path__ + "media/images/forms-icons/phone-icon-c95393a1a2cd4bd09ab17c48dc6eba24.svg";